import React from 'react'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import styles from '../EkgRecordingReviewScreen.css'
import SaveIcon from 'static/images/icons/content-save.svg'
import Loading from '../../../components/Loading'
import { checkESignaureFeatureEnabled, checkServiceInterpretationFeatureEnabled, checkServiceProviderFeatureEnabled } from '../../../../configs'
import ESignatureModal from '../../../../views/components/Modal/ESignatureModal'
import { showEsignModal } from '../../../store/appReducer'
import { ESIGN_MODAL_NAME } from '../../../../views/components/Common/AlertBar/Constants'
import { ESIGN_FORM_TITLE } from '../Util'

const AddInterpretationControls = props => {
  const {
    saveDisabled,
    handleOnAddInterpretationsCancelClick,
    handleOnAddInterpretationsSaveClick,
    isSubmitting,
    me,
  } = props

  const dispatch = useDispatch()
  // check if E-signaure feature is enabled and esign modal is opened
  const isEsignModalOpen = useSelector(state => state.app.isEsignModalOpen)
  const hasQTValues = useSelector(state => {
    if (state && state.form && state.form.qtValuesForm && state.form.qtValuesForm.values) {
      return state.form.qtValuesForm.values
    }
    return null
  })
  const selectedInterpretations = useSelector(state => {
    if (state && state.ekgRecordingReviewScreen) {
      return state.ekgRecordingReviewScreen.selectedInterpretations
    }
    return []
  })

  const isEsignaureEnabled = checkESignaureFeatureEnabled(me)
  const isServiceProviderEnabled = checkServiceProviderFeatureEnabled(me)
  const isServiceInterpretationFeatureEnabled = checkServiceInterpretationFeatureEnabled(me)

  // by defaut case for the service provider and isServiceInterpretationFeatureEnabled if not selected any interpretation
  const hasInterpretations = isServiceProviderEnabled && isServiceInterpretationFeatureEnabled && (selectedInterpretations.length > 0)

  const getModalName = () => {
    if (hasInterpretations && hasQTValues) return ESIGN_MODAL_NAME.EKG_INTERPRETATION_AND_QT_UPDATE
    if (hasQTValues) return ESIGN_MODAL_NAME.QT_UPDATE
    return ESIGN_MODAL_NAME.EKG_INTERPRETATION
  }
  /* on click of save button, open Esignature modal, if E-signaure (cfr-21-11-audit-trail) feature is enabled
    else continue with handle save functionality
  */
  const modalName = getModalName()
  const handleSave = () => {
    if (isEsignaureEnabled) {
      // handle modal
      dispatch(showEsignModal(modalName))
    } else {
      handleOnAddInterpretationsSaveClick()
    }
  }
  const intl = useIntl()

  return (
    <React.Fragment>
      {
        // Render EsignatureModal component if fr-21-11-audit-trail featue is enabled
        isEsignaureEnabled ? <ESignatureModal
          open={isEsignModalOpen}
          formTitle={ESIGN_FORM_TITLE[modalName]}
          confirmHandler={handleOnAddInterpretationsSaveClick}
          screenName={ESIGN_MODAL_NAME.EKG_INTERPRETATION}
        /> : null
      }
      <div className={styles.addInterpretationControls}>
        <div className={styles.row}>
          <a
            onClick={handleOnAddInterpretationsCancelClick}
            className={styles.cancelButton}
          >
            {intl.formatMessage({ id: 'button.cancel' })}
          </a>
          {isSubmitting ?
            <button
              className={styles.saveButtonLoading}
              disabled
            >
              <Loading />
            </button>
            :
            <button
              onClick={handleSave}
              className={styles.saveButton}
              disabled={saveDisabled}
            >
              <SaveIcon />
              {intl.formatMessage({ id: 'button.save' })}
            </button>
          }
        </div>
      </div>
    </React.Fragment>
  )
}

export default AddInterpretationControls



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/components/AddInterpretationControls.jsx